import * as React from "react"
import { graphql, useStaticQuery } from "gatsby"
import styled from "@emotion/styled"
import Layout from "components/layout"
import Container from "components/container"
import { H3, P } from "components/headings"
import SEO from "components/SEO"
import ModuleRender from "components/ModuleRender"
import { HeaderConfig } from "components/Header"
import { HeaderVariant } from "components/Header/types"
import { BreakPoints, mediaBreakpoint } from "settings/breakpoints"
import MediaSection from "components/sections/MediaSection"
import { css } from "@emotion/react"
import BrandImagesWithReviews from "components/BrandImagesWithReviews"
import DoubleBarChart from "components/DemocracyPerceptionIndex/DoubleBarChart"
import Media from "components/Media"
// import BrandImagesNew from "components/BrandImagesNew"
// import DpiForm from "components/Form/DpiForm"
// import PieChart from "../components/DemocracyPerceptionIndex/PieChart"
import BarChart from "../components/DemocracyPerceptionIndex/BarChart"
import Button from "../components/button"
import CoverBackground from "../images/Background-Dots.svg"

const query = graphql`
	query {
		contentfulPage(slug: { eq: "democracy-perception-index" }) {
			headerVariant
			seo {
				...SEO
			}
			sections {
				... on ContentfulAlternatingCards {
					...AlternatingCards
				}
				... on ContentfulBrandImagesSection {
					...BrandImages
				}
				... on ContentfulBrandImagesWithReviews {
					...BrandImagesWithReviews
				}
				... on ContentfulLandingSections {
					...Section
				}
				... on ContentfulReferencesSection {
					...ReferencesSection
				}
			}
		}
		dpiVideo: contentfulAsset(title: { eq: "Latana_DPI_2022" }) {
			...MediaOriginal
		}
		cdsVideo: contentfulAsset(title: { eq: "cds_2021" }) {
			...MediaOriginal
		}
		profilePic: contentfulAsset(title: { eq: "nico_jaspers_profile_pic" }) {
			...MediaOriginal
		}
		illustration: contentfulAsset(title: { eq: "DPI_dashboard_background" }) {
			...MediaOriginal
		}
		purpleDot: contentfulAsset(title: { eq: "Oval (2)" }) {
			...MediaOriginal
		}
		blueDot: contentfulAsset(title: { eq: "Rectangle 86" }) {
			...MediaOriginal
		}
		logo1: contentfulAsset(title: { eq: "DPI_logo1" }) {
			...MediaOriginal
		}
		logo2: contentfulAsset(title: { eq: "DPI_logo2" }) {
			...MediaOriginal
		}
		logo3: contentfulAsset(title: { eq: "DPI_logo3" }) {
			...MediaOriginal
		}
		logo4: contentfulAsset(title: { eq: "DPI_logo4" }) {
			...MediaOriginal
		}
		logo5: contentfulAsset(title: { eq: "DPI_logo5" }) {
			...MediaOriginal
		}
		logo6: contentfulAsset(title: { eq: "DPI_logo6" }) {
			...MediaOriginal
		}
		logo7: contentfulAsset(title: { eq: "DPI_logo7" }) {
			...MediaOriginal
		}
		logo8: contentfulAsset(title: { eq: "DPI_logo8" }) {
			...MediaOriginal
		}
		dpiPosterImage: contentfulAsset(title: { eq: "DPI_poster" }) {
			...MediaOriginal
		}
		cdsPosterImage: contentfulAsset(title: { eq: "CDS_poster" }) {
			...MediaOriginal
		}
		dpiMapImage: contentfulAsset(title: { eq: "dpi_map" }) {
			...MediaOriginal
		}
		dpiMapIndicator: contentfulAsset(title: { eq: "Indicator" }) {
			...MediaOriginal
		}
		logoReuters: contentfulAsset(title: { eq: "Black Reuters logo" }) {
			...MediaOriginal
		}
		logoPolitico: contentfulAsset(title: { eq: "Black Politico logo" }) {
			...MediaOriginal
		}
		logoTheGuardian: contentfulAsset(title: { eq: "Black The Guardian logo" }) {
			...MediaOriginal
		}
		logoNPR: contentfulAsset(title: { eq: "Black NPR logo" }) {
			...MediaOriginal
		}
		logoDerSpiegel: contentfulAsset(title: { eq: "Black Der Spiegel logo" }) {
			...MediaOriginal
		}
		logoWelt: contentfulAsset(title: { eq: "Black Welt logo" }) {
			...MediaOriginal
		}
	}
`

const VideoFormContainer = styled.section`
	display: flex;
	flex-direction: column;
	padding: 60px 0;
	background: #000000;
	color:white;
	${mediaBreakpoint(BreakPoints.LG)} {
		padding: 0 0 84px 0;
		margin-top: -80px;
	}
`

const VideoFormTop = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;

	${mediaBreakpoint(BreakPoints.LG)} {
		flex-direction: row;
	}
`

/* const VideoFormBottom = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;

	${mediaBreakpoint(BreakPoints.LG)} {
		flex-direction: row;
	}

	div {
		padding: 0;
	}

	div > div > div {
		transform-origin: center;

		${mediaBreakpoint(BreakPoints.LG)} {
			transform-origin: left;
			transform: scale(0.85);
		}

		img {
			margin-right: 10px;
		}
	}
` */

const VideoFormLeft = styled.div`
	height: 100%;
	width: 100%;
	margin-bottom: 20px;
	p{
		color:#ffffff;
	}
	${mediaBreakpoint(BreakPoints.LG)} {
		padding-right: 130px;
		width: 50%;
	}
`

const MainTitle = styled.h1`
	font-size: 4.8rem;
	line-height: 5.8rem;
	font-weight: 800;
	color: #fff;
`

export const Title = styled.h2`
	font-size: 4rem;
	line-height: 5rem;
	font-weight: 800;
	margin-bottom: 20px;
	color: White;
`

const VideoFormRight = styled.div`
	height: 100%;
	width: 100%;
	margin-bottom: 50px;

	[data-element="cover"] {
		padding: 0;
	}

	${mediaBreakpoint(BreakPoints.LG)} {
		width: 50%;
		margin-bottom: 0px;
	}
`

const ChartsContainer = styled.section`
	padding: 20px 0;
	background: #000000;
	&.whiteBg {
		background: none;
		background-color: #fff;
	}
`

const ChartsTop = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	text-align: center;
	margin-bottom: 40px;
`

/*
const PieChartsContainer = styled.div`
	display: flex;
	justify-content: center;
	flex-direction: column;

	${mediaBreakpoint(BreakPoints.MD)} {
		flex-direction: row;
	}
`
*/

const PieChartTitle = styled.h2`
	font-size: 2rem;
	line-height: 2.8rem;
	font-weight: 800;
	margin-bottom: 40px;

	${mediaBreakpoint(BreakPoints.MD)} {
		font-size: 4rem;
		line-height: 5rem;
	}
`

const ChartsBottom = styled.div`
	display: flex;
	flex-direction: column;

	${mediaBreakpoint(BreakPoints.MD)} {
		flex-direction: row;
	}
`

const ChartsLeft = styled.div`
	display: flex;
	flex-direction: column;
	p {
		color: #fff;
	}

	${mediaBreakpoint(BreakPoints.MD)} {
		padding-right: 55px;
		width: 50%;
	}

	${mediaBreakpoint(BreakPoints.LG)} {
		p {
			white-space: pre;
		}
	}
`

const ChartsRight = styled.div`
	span {
		font-size: 1rem;
		line-height: 2.8rem;
		font-weight: 400;
		opacity: 0.7;
	}

	${mediaBreakpoint(BreakPoints.MD)} {
		width: 50%;
		padding-left: 80px;
	}
`

const whiteText = css`
	color: #fff;
`

const VideoCountdownContainer = styled.section`
	padding: 40px 0;
	background: #000;
	p, span{
		color: #fff;
	}
	a {
		color: white;
		text-decoration: underline!important;
	}
`
const ReviewAboutContainer = styled.section`
	padding: 80px 0;
	background: #000;

	a {
		text-decoration: none;
	}
`

const Review = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;

	${mediaBreakpoint(BreakPoints.MD)} {
		flex-direction: row;
	}
`

const ProfilePictureContainer = styled.div`
	min-width: fit-content;
	display: flex;
	justify-content: center;

	${mediaBreakpoint(BreakPoints.MD)} {
		align-items: center;
	}
`

const ProfilePicture = styled.img`
	width: 300px;
	height: 300px;
	margin-bottom: 40px;

	${mediaBreakpoint(BreakPoints.MD)} {
		margin-right: 92px;
		margin-bottom: 0;
	}
`

const ReviewRight = styled.div`
	display: flex;
	min-height: 100%;
	font-size: 2.4rem;
	line-height: 3.2rem;
	color: #fff;
	font-weight: 800;
	flex-direction: column;
	justify-content: center;
	text-align: center;

	${mediaBreakpoint(BreakPoints.MD)} {
		text-align: left;
		font-size: 3.2rem;
		line-height: 4.2rem;
	}

	> span {
		color: #00c6bc;
		font-size: 5rem;
	}
`

const Author = styled.div`
	margin-top: 20px;
	font-size: 1.6rem;
	line-height: 1.6rem;
	font-weight: 600;

	span {
		font-weight: 800;
	}
`

const About = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;

	${mediaBreakpoint(BreakPoints.MD)} {
		flex-direction: row;
	}
`

const AboutLeft = styled.div`
	margin-top: 100px;
	width: 100%;

	button {
		display: none;
	}

	${mediaBreakpoint(BreakPoints.MD)} {
		margin-right: 50px;
		width: 50%;

		button {
			display: block;
		}
	}
`

const AboutRight = styled.div`
	width: 100%;
	margin-top: 50px;
	display: flex;
	flex-direction: column;
	position: relative;
    top: -50px;
    right: 0;
	button {
		margin-top: 50px;
	}

	${mediaBreakpoint(BreakPoints.MD)} {
		width: 50%;
		right: -60px;
		button {
			display: none;
		}
	}
`
const AboutImage = styled.img`
	transform: scale(2.1);
`


const footerCoverStyles = css`
	display: flex;
	align-items: flex-start;
	min-height: 496px;
	background: url("${CoverBackground}") no-repeat center top var(--main-color);
	background-size: cover;
	padding: 75px 0 152px;
	min-height: 552px;
	${mediaBreakpoint(BreakPoints.SM)} {
		min-height: 496px;
		align-items: center;
		padding: 116px 0 80px;
	}
`

const coverHeadingStyles = css`
	color: #fff;
	text-align: center;
	margin: 0 0 24px;
`
const coverDescriptionStyles = css`
	width: 432px;
	max-width: 100%;
	text-align: center;
	color: #fff;
	margin: 0 0 42px;
`
const coverContainerStyles = css`
	display: flex;
	flex-direction: column;
	align-items: center;
`

export const Title2 = styled.h1`
	font-size: 2.4rem;
	line-height: 2.4rem;
	color: #fff;
`

export const SubTitle2 = styled.h3`
	font-size: 1.2rem;
	line-height: 1.2rem;
	font-weight: 600;
	color: #fff;
`

const ChartsSecondary = styled.div`
	text-align: left;
	width: 100%;
	margin-top: 30px;
`

const Map = styled.div`
	width: 100%;

	.gatsby-image-wrapper {
		width: 100% !important;
	}
`

const buttonContainer = styled.div`
	width: 100%;

	${mediaBreakpoint(BreakPoints.MD)} {
		width: fit-content;
	}
`

const SubMap = styled.div`
	width: 100%;
	display: flex;
	justify-content: center;
`
/* const Form = styled.div `
	padding-top: 4rem;
`

const TopContent = styled.h3 `
	font-style: normal;
	font-weight: 700;
	font-size: 2rem;
	line-height: 5rem;
	letter-spacing: 0.1em;
	text-transform: uppercase;
	background: linear-gradient(90deg, #895CF6 0%, #00C1B7 48.35%);
	-webkit-background-clip: text;
  	-webkit-text-fill-color: transparent;
`
 */

const DPI_SHARE_URL = "https://youtu.be/_ca4D_c6_1Q"

const Democracy = () => {
	const {
		contentfulPage,
		cdsVideo,
		dpiVideo,
		profilePic,
		illustration,
		logo1,
		logo2,
		logo3,
		logo4,
		logo5,
		logo6,
		logo7,
		logo8,
		dpiPosterImage,
		cdsPosterImage,
		dpiMapImage,
		dpiMapIndicator,
		// logoReuters,
		// logoPolitico,
		// logoTheGuardian,
		// logoNPR,
		// logoDerSpiegel,
		// logoWelt,
	} = useStaticQuery(query)
	const { sections, seo, headerVariant } = contentfulPage
	const logos = [logo1, logo2, logo3, logo4, logo5, logo6, logo7, logo8]
	/* const pressLogos = {
		heading: {
			heading: "Featured in",
		},
		logos: [logoReuters, logoPolitico, logoTheGuardian, logoNPR, logoDerSpiegel, logoWelt],
	} */

	const headerConfig: HeaderConfig = React.useMemo(() => {
		return {
			variant: headerVariant || HeaderVariant.Default,
		}
	}, [headerVariant])

	/* const pieCharts = [
		{
			color: "#01C1B7",
			value: 78,
			description: "of people around the world say that democracy is important to have in their country",
			whiteText: true,
			animate: true,
		},
		{
			color: "#E2154A",
			value: 43,
			description: "of people living in democracies say their government only serves the interests of a minority",
		},
	]

	const barCharts = [
		{
			label: "China",
			color: "#01C1B7",
			value: 95,
		},
		{
			label: "Vietnam",
			color: "#01C1B7",
			value: 95,
		},
		{
			label: "Greece",
			color: "#01C1B7",
			value: 89,
		},
		{
			label: "World Average",
			color: "#FFF",
			value: 70,
		},
		{
			label: "France",
			color: "#E2154A",
			value: 46,
		},
		{
			label: "Chile",
			color: "#E2154A",
			value: 39,
		},
		{
			label: "Brazil",
			color: "#E2154A",
			value: 34,
		},
	]
*/
	const barCharts2 = [
		{
			label: "Global",
			color: "#01C1B7",
			value: 58,
		},
		{
			label: "Free",
			color: "#01C1B7",
			value: 51,
		},
		{
			label: "Less Free",
			color: "#01C1B7",
			value: 65,
		},
		{
			label: "Asia",
			color: "#01C1B7",
			value: 75,
		},
		{
			label: "Europe",
			color: "#E2154A",
			value: 45,
		},
		{
			label: "Latin America",
			color: "#E2154A",
			value: 42,
		},
	]

	/*	const text = `Overall, 70% percent of people believe their government
responded “well” to the COVID 19 crisis (as of May 2020).
The highest satisfaction was in China, Vietnam and Greece.
The lowest was in Brazil, Chile, France.` */

	const threatsBarChartData = [
		{
			label: "Economic Inequality",
			disagree: 15,
			agree: 64,
		},
		{
			label: "Limits on Free Speech",
			disagree: 25,
			agree: 53,
		},
		{
			label: "Unfair or Fraudulent Elections",
			disagree: 27,
			agree: 49,
		},
		{
			label: "Power of Big Tech",
			disagree: 23,
			agree: 48,
		},
		{
			label: "US’s Influence",
			disagree: 26,
			agree: 44,
		},
		{
			label: "Foreign Election Interference",
			disagree: 29,
			agree: 42,
		},
		{
			label: "China’s Influence",
			disagree: 32,
			agree: 38,
		},
		{
			label: "Russia’s Influence",
			disagree: 36,
			agree: 28,
		},
	]

	return (
		<>
			<SEO {...seo} />
			<Layout headerConfig={headerConfig} footerConfig={{ hideDemo: true, hideNewsletter: false, variant: "dark-footer" }}>
				<ModuleRender sections={sections} />
				<VideoFormContainer>
					<Container>
						<VideoFormTop>
							<VideoFormLeft>
								{/* <TopContent>Coming May 30th 2022</TopContent> */}
								<Title>Democracy Perception Index Report 2022</Title>
								<P>
								The Democracy Perception Index (DPI) is the world’s largest annual study on democracy, 
								conducted by Latana in collaboration with the Alliance of Democracies, to monitor attitudes  
								towards democracy from around the world.   
								</P>
								<Button
									type="button"
									variant="primary-new"
									link={{ slug: "democracy-perception-index-report-2022" }}
									label="Download Now"
								/>
							</VideoFormLeft>
							<VideoFormRight>
								{dpiVideo && (
									<MediaSection
										showVideoControls
										videoShareUrl={DPI_SHARE_URL}
										media={dpiVideo}
										videoPosterImage={dpiPosterImage}
										videoAutoplay
									/>
								)}
							</VideoFormRight>
						</VideoFormTop>
						{/* 
						<VideoFormBottom>
							<BrandImagesNew blackText brandImages={pressLogos} />
						</VideoFormBottom> 
						<Form><DpiForm /></Form> */}
					</Container>
				</VideoFormContainer>
				<ChartsContainer>
					<Container>
						<MediaSection
							title="Highlights from the DPI 2021"
							videoAutoplay
							muted
							embedYoutubeId="kEh11QAA-dg"
							theme="white-text"
							customStyle={css`
								margin-bottom: 80px;

								[data-element="cover"] {
									padding: 0;
								}
							`}
						/>
						<ChartsTop>
							<MainTitle css={whiteText}>DPI 2021 Key Findings</MainTitle>
							<PieChartTitle css={whiteText}>Threats to Democracy</PieChartTitle>
							<DoubleBarChart
								title="Economic inequality is the biggest perceived threat to democracy"
								subTitle="% agree that ______ is a threat to democracy in their country"
								data={threatsBarChartData}
								whiteTheme
							/>
						</ChartsTop>
					</Container>
				</ChartsContainer>
				<ChartsContainer>
					<Container>
						<ChartsTop>
							<MainTitle>Democracy During COVID</MainTitle>
							<ChartsSecondary>
								<Title2>COVID-19: Europe and America are failing in the eyes of their citizens</Title2>
								<SubTitle2>% say that their country is responding well to the COVID 19 crisis</SubTitle2>
							</ChartsSecondary>
							<Map>
								<Media {...dpiMapImage} />
							</Map>
							<SubMap>
								<Media {...dpiMapIndicator} />
							</SubMap>
						</ChartsTop>
						<ChartsBottom style={{ marginTop: "120px" }}>
							<ChartsLeft>
								<Title>People in Asia are most satisfied with their country’s response</Title>
								<P style={{ whiteSpace: "normal" }}>
									Average satisfaction in Asia is significantly higher than in Europe and Latin America. People living
									in free democracies are also much less satisfied with their country’s response, with only 51% saying
									their country is responding well.
								</P>
							</ChartsLeft>
							<ChartsRight>
								{(barCharts2 || []).map(chart => (
									<BarChart value={chart.value} colorHEX={chart.color} animate>
										{chart.label}
									</BarChart>
								))}
								<span>% say that their country is responding well to the COVID 19 crisis</span>
							</ChartsRight>
						</ChartsBottom>
					</Container>
				</ChartsContainer>
				{/* <ChartsContainer>
					<Container>
						<ChartsTop>
							<MainTitle css={whiteText}>2020 Key Findings</MainTitle>
							<PieChartTitle css={whiteText}>Democracy Perception</PieChartTitle>
							<PieChartsContainer>
								{(pieCharts || []).map(chart => (
									<PieChart value={chart.value} whiteText animate colorHEX={chart.color}>
										{chart.description}
									</PieChart>
								))}
							</PieChartsContainer>
						</ChartsTop>
						<ChartsBottom>
							<ChartsLeft>
								<Title css={whiteText}>Initial Response to COVID-19</Title>
								<P css={whiteText}>{text}</P>
							</ChartsLeft>
							<ChartsRight>
								{(barCharts || []).map(chart => (
									<BarChart value={chart.value} colorHEX={chart.color} animate whiteText>
										{chart.label}
									</BarChart>
								))}
								<span css={whiteText}>% say their government is responding “well” (May 2020)</span>
							</ChartsRight>
						</ChartsBottom>
					</Container>
				</ChartsContainer> */}
				<VideoCountdownContainer>
					{cdsVideo && (
						<MediaSection
							title="Copenhagen Democracy Summit 2021"
							innerHTML={`The Copenhagen Democracy Summit 2021, <a href='https://www.allianceofdemocracies.org' target='_blank'>an initiative of the Alliance of Democracies Foundation</a>, will take place in hybrid format on May 10-11, 2021. It will draw participants from business executives, political leaders, activists and other democracy supporters to discuss the future of global democracy, US leadership and post-COVID recovery, technology and democratic trust.`}
							showVideoControls
							playVideoWhenInView
							media={cdsVideo}
							videoPosterImage={cdsPosterImage}
							loop={false}
							muted
						/>
					)}
					<Container
						css={buttonContainer}
						customStyles={css`
							display: flex;
							justify-content: center;
							margin-top: 60px;
						`}
					>
						<Button
							label="Learn More"
							variant="primary-new"
							type="button"
							link={{
								url: "https://copenhagendemocracysummit.com/",
							}}
							newTab
						/>
					</Container>
				</VideoCountdownContainer>
				<ReviewAboutContainer>
					<Container>
						<Review>
							<ProfilePictureContainer>
								<ProfilePicture src={profilePic.file.url} alt="Nico Jasper's" />
							</ProfilePictureContainer>
							<ReviewRight>
								<span>“</span>
								As we’re entering a period of profound economic, political and societal changes, democracy is more
								important than ever. It enables us to have a say in what we want our collective future to look like.
								<Author>
									<span>Dr. Nico Jaspers</span>, CEO Latana
								</Author>
							</ReviewRight>
						</Review>
						<About>
							<AboutLeft>
								<MainTitle css={whiteText}>About Latana</MainTitle>
								<P css={whiteText}>
									Latana is an international market leader in consumer insights and uses its technology to understand
									the underlying forces behind the opinions of people worldwide. Latana&apos;s AI-powered brand tracking
									solution leverages key insights to help companies grow their brand and campaign performance.{" "}
								</P>
								<Button label="Learn More" variant="primary-new" type="button" link={{ slug: "product" }} />
							</AboutLeft>
							<AboutRight>
								<AboutImage src={illustration.file.url} alt="Product overview" />
								<Button label="Learn More" variant="primary-new" type="button" link={{ slug: "/" }} />
							</AboutRight>
						</About>
					</Container>
				</ReviewAboutContainer>
				{logos && (
					<BrandImagesWithReviews heading="You're in Good Company" id="DPI" images={logos} compact blackTheme />
				)}
				<section css={footerCoverStyles}>
					<Container css={coverContainerStyles}>
						<H3 css={coverHeadingStyles}>
							Get the consumer insights
							<br /> that matter most
						</H3>
						<P css={coverDescriptionStyles}>
							Learn how you can use Latana to collect the data you need to make better decisions.
						</P>
						<Button
							label="Get in touch"
							variant="black"
							link={{
								slug: "contact-us",
							}}
							type="button"
						/>
					</Container>
				</section>
			</Layout>
		</>
	)
}

export default React.memo(Democracy)
